









































































































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import ProfileList from "./ProfileList.vue";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

interface LeafCategory {
  name: string;
  namePath: string;
}

interface Subcategory {
  name: string;
  namePath: string;
  subcategories: LeafCategory[];
}

interface Category {
  name: string;
  subcategories: Subcategory[];
  namePath: string;
}

interface Profile {
  accountId: string;
  companyId: string;
  categories: string[];
  createdBy: string;
  createdAt: string;
  deletedAt: string;
  isDefault: boolean;
  profileId: string;
  profileName: string;
  updatedBy: string;
  updatedAt: string;
  isOutdated: boolean;
}

@Component({
  components: {
    CompaniesSwitcher,
  },
})
export default class BulkProfileCreate extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;
  @Prop() private profileId!: string;

  categories: Category[] = [];
  selectedCategoryPaths: string[] = [];
  isProfileAlreadyDefault = false;
  isDefaultProfile = false;
  profileName = "";
  isProfileOutdated = false;
  isProfileNameInvalid = false;
  loading = false;
  currentDefaultProfile = "";
  private errorMessageTop = "";

  mounted() {
    this.$store.commit("startLoading");
    this.loading = true;
    this.$api
      .get("api/categories/all")
      .then((result: any) => {
        this.categories = result.data;
        this.$api
          .get(
            `item-classification-api/v1/profiles/${this.companyId}/${this.profileId}`
          )
          .then((response) => {
            const profile: Profile = response.data;
            this.selectedCategoryPaths = this.expandedCategoryPaths(
              profile.categories
            );
            this.isDefaultProfile = profile.isDefault;
            this.isProfileAlreadyDefault = profile.isDefault;
            this.profileName = profile.profileName;
            this.isProfileOutdated = profile.isOutdated;
            this.$api
              .get(
                `item-classification-api/v1/profiles/${this.companyId}/default`
              )
              .then((response) => {
                this.currentDefaultProfile = response.data.profileName;
                this.$store.commit("stopLoading");
                this.loading = false;
              })
              .catch((error) => {
                if (error.response.status === 404) {
                  this.currentDefaultProfile = "";
                  this.$store.commit("recordError", "");
                }
                this.$store.commit("stopLoading");
                this.loading = false;
              });
          });
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  isSelected(namePath: string) {
    return this.selectedCategoryPaths.includes(namePath);
  }

  private onCategoryClicked(e, category: Category) {
    this.toggleCategoryPathSelection(category.namePath);
  }

  private onSubcategoryClicked(e, subcategory: Subcategory) {
    this.toggleCategoryPathSelection(subcategory.namePath);
  }

  private onLeafClicked(e, leaf: LeafCategory) {
    this.toggleCategoryPathSelection(leaf.namePath);
  }

  private toggleCategoryPathSelection(namePath: string) {
    if (this.selectedCategoryPaths.indexOf(namePath) >= 0) {
      this.selectedCategoryPaths = this.selectedCategoryPaths.filter(
        (p) => !p.startsWith(namePath)
      );
    } else {
      this.selectedCategoryPaths = [...this.selectedCategoryPaths, namePath];
    }
  }

  private saveProfile() {
    if (this.profileName === "") {
      this.isProfileNameInvalid = true;
      return;
    }
    if (
      this.isDefaultProfile &&
      this.currentDefaultProfile &&
      this.currentDefaultProfile !== "" &&
      this.profileName !== this.currentDefaultProfile
    ) {
      this.openDefaultDialog();
    } else {
      this.updateProfile();
    }
  }

  private openDefaultDialog() {
    (this.$refs["set-default-profile"] as any).showModal();
  }

  private updateProfile() {
    this.closeDefaultDialog();
    this.$store.commit("startLoading");
    const categoryPaths = this.dedupedCategoryPaths();
    this.$api
      .put(
        `item-classification-api/v1/profiles/${this.companyId}/${this.profileId}`,
        {
          categories: categoryPaths,
          profileName: this.profileName,
        }
      )
      .then((response) => {
        if (this.isDefaultProfile) {
          this.$api
            .put(
              `item-classification-api/v1/profiles/${this.companyId}/default`,
              null,
              { params: { profileId: this.profileId } }
            )
            .then((res) => {
              this.redirectToProfiles();
            });
        } else {
          this.redirectToProfiles();
        }
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private redirectToProfiles() {
    this.$store.commit("stopLoading");
    this.$store.commit(
      "recordToast",
      `"${this.profileName}" successfully updated!`
    );
    this.$router.replace({
      path: `/classification/${this.accountId}/${this.companyId}/profiles`,
    });
  }

  private closeDefaultDialog() {
    (this.$refs["set-default-profile"] as any).close();
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/profiles`,
    });
  }

  private dedupedCategoryPaths() {
    const allPaths = this.selectedCategoryPaths;
    return this.selectedCategoryPaths.filter((path) => {
      return !allPaths
        .filter((p) => p !== path)
        .some((p) => p.startsWith(path) && p.length > path.length);
    });
  }

  private removeOutdatedPaths(paths: string[]): string[] {
    const allPossibleNamePaths = this.categories.flatMap((c) => {
      const categoryPath = c.namePath;
      const subcategoryPaths = c.subcategories
        ? c.subcategories.map((s) => s.namePath)
        : [];
      const leafPaths = c.subcategories
        ? c.subcategories.flatMap((s) =>
            s.subcategories ? s.subcategories.map((leaf) => leaf.namePath) : []
          )
        : [];
      return [categoryPath, ...subcategoryPaths, ...leafPaths];
    });
    return paths.filter((p) => allPossibleNamePaths.indexOf(p) >= 0);
  }

  private expandedCategoryPaths(categoryPaths: string[]): string[] {
    const allPaths = categoryPaths.flatMap((path) => {
      const splits = path.split(" > ");
      return [
        splits[0],
        splits.length >= 2 ? `${splits[0]} > ${splits[1]}` : splits[0],
        splits.length === 3 ? path : splits[0],
      ];
    });
    return this.removeOutdatedPaths([...new Set(allPaths)]);
  }
}
